<div class="popup-container">

<div id="err">
    <h2 class="mb-0 mr-0">LOGS</h2>
    <img class="close_button" (click)="closeDialog()" src="assets/images/Close_btn.svg">
</div>
<div *ngIf="displaydata?.length>0 ;else elseStatement">
<div class="err-content"  *ngFor="let i of displaydata">{{i}}</div>
</div>
<ng-template #elseStatement>
    <div class="logs-content text-center">
       No Logs Found
</div>
</ng-template>
</div>